import React from 'react';

import { RowInfo } from '../Common/RowInfo';
import { StyledCard, StyledDivider } from '../style';
import { REQUEST_PARAMS } from '../../../../testUtils';

export const RequestParams = ({ isLoading, request }) => {
  const { app, badv, regs, user } = request || {};
  const bundle = app?.bundle;
  const publisherId = app?.publisher?.id;
  return (
    <StyledCard title="Request Params" loading={isLoading} data-testid={REQUEST_PARAMS}>
      {bundle && <RowInfo title="appBundle" data={bundle} />}
      <RowInfo title="appContentGenre" data={app?.content?.genre} />
      <RowInfo title="appContentID" data={app?.content?.id} />
      {publisherId && <RowInfo title="appPublisherID" data={publisherId} />}
      {!!badv?.length && (
        <>
          <StyledDivider height={24} />
          <RowInfo title="badv" data={badv?.join(',')} />
        </>
      )}
      <StyledDivider height={24} />
      <RowInfo title="regsCoppa" data={regs?.coppa} />
      <RowInfo title="regsExt" data={regs?.ext || 'none'} />
      <StyledDivider height={24} />
      <RowInfo title="userID" data={user?.id} />
    </StyledCard>
  );
};
